// src/client/components/profile-manager/detail-view/ReadOnlyField.tsx

interface ReadOnlyFieldProps {
  label: string;
  value: string | number | Date | null;
  copyable?: boolean;
}

export default function ReadOnlyField({
  label,
  value,
  copyable = false,
}: ReadOnlyFieldProps) {
  // ✅ FIX: Proper value conversion to prevent React Error #31
  const displayValue = (() => {
    if (value === null || value === undefined) {
      return '—';
    }
    if (value instanceof Date) {
      return value.toLocaleString('de-DE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      });
    }
    return String(value);
  })();

  const copyValue = value instanceof Date ? value.toISOString() : String(value || '');

  const handleCopy = () => {
    if (value !== null && value !== undefined) {
      navigator.clipboard.writeText(copyValue);
      console.log('[ReadOnlyField] Copied:', copyValue);
    }
  };

  return (
    <div className="flex items-center py-2 border-b">
      <label className="w-32 text-sm font-medium text-gray-500">
        {label}:
      </label>
      <div className="flex-1 flex items-center justify-between">
        <span className="text-sm text-gray-600">{displayValue}</span>
        {copyable && value !== null && value !== undefined && (
          <button
            onClick={handleCopy}
            className="text-xs text-blue-600 hover:text-blue-800"
          >
            Copy
          </button>
        )}
      </div>
    </div>
  );
}